import {EmblaCarouselType} from 'embla-carousel';
import {create} from 'zustand';

import {CardButton} from '@/root/models/card';

type EmblaStore = {
  emblaApi: EmblaCarouselType | undefined;
  setEmblaApi: (emblaApi: EmblaCarouselType | undefined) => void;
};

type UtilButtonsStore = {
  utilButtons: CardButton[];
  setUtilButtons: (utilButtons: CardButton[]) => void;
};

type ExpiredNoticeStore = {
  visible: boolean;
  setVisible: (isVisibleExpiredNotice: boolean) => void;
};

export const useEmblaStore = create<EmblaStore>((set) => ({
  emblaApi: undefined,
  setEmblaApi: (emblaApi) => set({emblaApi})
}));

export const useUtilButtonsStore = create<UtilButtonsStore>((set) => ({
  utilButtons: [],
  setUtilButtons: (utilButtons) => set({utilButtons})
}));

export const useExpiredNoticeStore = create<ExpiredNoticeStore>((set) => ({
  visible: false,
  setVisible: (visible: boolean) => set({visible})
}));
